import type { CityChoiceResult, RealSiteNotice, RealSitePreview } from "@/shared/contracts";
import { ApiError } from "@/shared/api/errors";
import type { HomePlaceService, ServiceContext } from "@/shared/services/types";

/**
 * 换住处的写和预览（UI2-HOME-SMALL-01）。读住处走 session.homePlace，这里只放老家补真实住处的告知、预览、确认，以及已入住的家选城。
 * 接口口径见后端 routers/web/cities.py（CITY-01 v3 11.4、R4）。
 */
export function createLiveHomePlaceService({ api }: ServiceContext): HomePlaceService {
  const pet = (petId?: string | null) => ({ pet_id: petId ?? undefined });
  return {
    realSiteNotice: (petId, signal) => api.request<RealSiteNotice>("/home/place/real-site/notice", { query: pet(petId), signal }),
    realSiteNoticeSeen: (petId) => api.request<RealSiteNotice>("/home/place/real-site/notice", { method: "POST", query: pet(petId) }),
    realSitePreview: (petId, signal) => api.request<RealSitePreview>("/home/place/real-site/preview", { query: pet(petId), signal }),
    confirmRealSite: (siteId, petId) => api.request<RealSitePreview>("/home/place/real-site", { method: "POST", query: pet(petId), body: { site_id: siteId } }),
    chooseCity: (cityId, petId) => api.request<CityChoiceResult>("/home/place/city", { method: "POST", query: pet(petId), body: { city_id: cityId } }),
  };
}

/** 演示模式照 identity 的做法：不出告知，预览、确认、选城一律不支持——不在演示里假装换了住处。 */
export function createFixtureHomePlaceService(): HomePlaceService {
  const unsupported = async (): Promise<never> => { throw ApiError.capability("home.place", "演示模式不换住处。"); };
  return {
    realSiteNotice: async () => ({ show: false }),
    realSiteNoticeSeen: async () => ({ show: false }),
    realSitePreview: unsupported,
    confirmRealSite: unsupported,
    chooseCity: unsupported,
  };
}
